import React from 'react';
import Colors, { ColorSchemes } from './colors';
import Theme from './index';
const ThemeContext = /*#__PURE__*/React.createContext({
  colorScheme: ColorSchemes.LIGHT,
  colors: Colors[ColorSchemes.LIGHT],
  theme: Theme
});
export default ThemeContext;